import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ArendeTyp } from '../interfaces/arendeTyp.interface';
import { BeslutTyp } from '../interfaces/beslutTyp.interface';

@Component({
    selector: 'beslut-icon',
    template: `<span [className]="'beslut-icon beslut-icon-' + beslutTyp.typ.substring(0, 2)">{{ arendeTyp.typ === 'rek' ? 'R' : 'B' }}<small>{{ beslutTyp.typ.substring(1) }}</small></span>`,
    styles: [`
    .beslut-icon {
      width: 2.5rem;
      padding: .125em;
      background-color: #000;
      color: #fff;
      border-radius: .5rem;
      display: inline-block;
      line-height: 1rem;
      text-transform: uppercase;
      text-align: center;
      font-weight: 600
    }

    .beslut-icon.beslut-icon-b1 {
      background-color: #b6d7a8;
      color: #000
    }

    .beslut-icon.beslut-icon-b2 {
      background-color: #ffe599;
      color: #000
    }

    .beslut-icon.beslut-icon-b3 {
      background-color: #d5a6bd;
      color: #000
    }

    .beslut-icon.beslut-icon-b4 {
      background-color: #ffe599;
      color: #000
    }

    .beslut-icon.beslut-icon-b5 {
      background-color: #a4c2f4;
      color: #000
    }

    .beslut-icon small {
      font-size: .75rem;
      font-weight: inherit
    }`],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BeslutIconComponent {
  @Input() public arendeTyp: ArendeTyp;
  @Input() public beslutTyp: BeslutTyp;

}
